import { Cell } from '../../../../components/common/table/Cell/Cell';
import { Row } from '../../../../components/common/table/Row/Row';
import './EventListRow.scss';
import { format } from 'date-fns';
import '../EventList.scss';

export interface EventListRowProps {
  _id: string;
  patient_id: string;
  createdDateTime: string;
  plan_name: string;
  station: string;
  machine: string;
  status: string;
  onDetailsClick: (id: string) => void;
  index: number;
}

export function EventListRow({ _id, patient_id, createdDateTime, plan_name, station, machine, status, onDetailsClick, index }: EventListRowProps) {
  const handleDetailsClick = () => {
    onDetailsClick(_id);
  };

  return (
    <Row index={index} classes="row-container" onClick={handleDetailsClick}>
      <Cell>{format(new Date(createdDateTime), 'yyyy-MM-dd HH:MM:SS')}</Cell>
      <Cell>{status}</Cell>
      <Cell>{plan_name}</Cell>
      <Cell capitalized>{station}</Cell>
      <Cell>{patient_id}</Cell>
      <Cell capitalized>{machine}</Cell>
    </Row>
  );
}
